export const types = {
    SET_REGIONS: "SET_REGIONS",
    SET_TAXES: "SET_TAXES",

    FETCH_REGIONS_ASYNC: "FETCH_REGIONS_ASYNC",
    FETCH_TAXES_ASYNC: "FETCH_TAXES_ASYNC",
};
